module.exports = __webpack_public_path__ + "img/messagespleno.40648b6b.svg";